import Modal from './Modal'
import { isFunction } from '../../utils/dataType'

let iModal = {}

let installed = false

iModal.install = function(Vue) {
	if (installed) return
	Vue.prototype.$Modal = {}
	const modalContainer = document.createElement('div')
	document.body.appendChild(modalContainer)
	Vue.prototype.$Modal.show = ({ modalInfo, onOk, onCancel }) => {
		let ModalTemp = Vue.extend({
			template: `<Modal
            @onOk="onOk"
            @onCancel="onCancel"
            @hideModal="hideModal"
            v-bind="modalInfo"
        >
        </Modal>`,
			methods: {
				onOk() {
					isFunction(onOk) && onOk()
				},
				onCancel() {
					isFunction(onCancel) && onCancel()
				},
				hideModal() {
					tpl && tpl.parentNode.removeChild(tpl)
					this.$destroy()
				},
			},
			data() {
				return {
					modalInfo,
				}
			},
			components: {
				Modal,
			},
		})

		let tpl = new ModalTemp().$mount().$el
		modalContainer.appendChild(tpl)

		return () => modalContainer.removeChild(tpl)
	}

	Vue.prototype.$Modal.hideAll = () => {
		let modals = modalContainer.querySelectorAll('.modal-container-wrap')
		if (modals.length > 0) {
			for (let i = 0; i < modals.length; i++) {
				modalContainer.removeChild(modals[i])
			}
		}
	}

	Vue.component('modal', {
		template: `
            <Modal
              v-if="modelShow"
              @onOk="onOk"
              @onCancel="onCancel"
              @hideModal="hideModal"
              v-bind="modalInfo"
            >
            <slot slot="header" name="header"></slot>
            <slot></slot>
            <slot slot="footer" name="footer"></slot>
          </Modal>`,
		data() {
			return {
				modelShow: false,
			}
		},
		props: {
			modalInfo: {
				type: Object,
				default: () => ({}),
			},
			value: Boolean,
		},
		components: {
			Modal,
		},
		model: {
			prop: 'value',
			event: 'update',
		},
		methods: {
			onOk() {
				this.$emit('onOk')
			},
			onCancel() {
				this.$emit('onCancel')
			},
			hideModal() {
				this.modelShow = false
				this.$emit('update', this.modelShow)
			},
		},
		watch: {
			value(v) {
				this.modelShow = v
			},
		},
	})

	installed = true
}
export default iModal
